import {defaultSelectedContact} from './state';
import {setTime} from '@syncfusion/ej2-vue-schedule';

export function setTooltipParamTable(state, paramTable) {
    state.parameters.map(p => {
        if (p.paramtable_id == paramTable.id) {
            p.tooltip = paramTable.code_table + ' - ' + paramTable.name_table;
        }
    });
}

// Establece un valor para identificationTypes
export function setIdentificationTypes(state, identificationTypes) {
    state.identificationTypes = identificationTypes;
    let identification_type = state.identificationTypes.find(it => it.code_parameter === '02');

    if (identification_type) {
        state.client.identification_type = identification_type.id;
    }
}

export function setReasonsVisit(state, data) {
    state.reasonsVisit = data;
}

export function setBecauseKindFoundOut(state, data) {
    state.becauseKindFoundOut = data;
}

// Establece un valor para complete
export function setComplete(state, complete) {
    state.complete = complete;
}

// Establece un valor para complete
export function fetchClientComponent(state, contact) {

    if (contact && !contact.customer) {
        contact.customer = {
            required_purchase_order: 0
        };
    }

    if (!state.show_component) {
        if (contact) {
            state.client = contact;
        } else {
            state.client = defaultSelectedContact();
        }
    }

    state.contacts = [];
    state.params_contacts.contact_id = null;
    state.params_contacts.contact_warehouse_id = null;

    state.show_component = !state.show_component;
}

// Establece un valor para complete
export function fetchClientSearch(state, client) {

    if (client && !client.customer) {
        client.customer = {
            required_purchase_order: 0
        };
    }

    state.client = client;
    state.client.price_list_id = state.selected_model.price_list_id;
}

// Establece un valor para el componente
export function clearModal(state) {
    state.client = defaultSelectedContact();
    state.client.price_list_id = state.selected_model.price_list_id;
    setDepartmentCityDefault(state);
}

// Establece un valor para el los parametros
export function setParamsContacts(state, filter) {
    state.params_contacts.filter = filter;
}

// Establece un valor para el los contactos
export function setContacts(state, contacts) {
    let contacts_filtered = [];

    const identification = state.client.identification;

    if (state.params_contacts.with_contact_warehouses && state.params_contacts.filter) {
        let filter_parts = state.params_contacts.filter
            .trim()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .split(' ');

        if (filter_parts && filter_parts.length > 1) {
            contacts_filtered = contacts.map(c => {
                let final_filter_parts = [];

                filter_parts.map(fp => {
                    let match_contact = c.full_name_with_identification
                        .trim()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .toLowerCase()
                        .includes(fp);

                    if (!match_contact) {
                        final_filter_parts.push(fp);
                    }
                });

                let warehouses = [];

                if (final_filter_parts.length) {
                    warehouses = c.warehouses.filter(w => {
                        let match = false;

                        final_filter_parts.map(fp => {
                            if (!match) {
                                match = w.address
                                    .trim()
                                    .normalize('NFD')
                                    .replace(/[\u0300-\u036f]/g, '')
                                    .toLowerCase()
                                    .includes(fp);
                            }
                        });

                        return match;
                    });
                } else {
                    warehouses = c.warehouses;
                }

                return {
                    ...c,
                    warehouses: warehouses
                };
            });
        } else {
            contacts_filtered = contacts;
        }
    } else {
        contacts_filtered = contacts;
    }

    state.contacts = contacts_filtered;

    state.client = defaultSelectedContact();
    state.client.identification = identification;
    state.client.price_list_id = state.selected_model.price_list_id;
}

// Establece un valor para el las listas de precios
export function setPriceLists(state, priceLists) {
    state.priceLists = priceLists;
}

// Establece un valor para las categorías de clientes
export function setCategoriesCustomers(state, categoriesCustomers) {
    state.categoriesCustomers = categoriesCustomers;
}

export function setIdentification(state, identification) {
    state.client.identification = identification;
}

export function removeId(state) {
    state.client.id = null;
}
export function setContactVehicles(state, data) {
    state.contactVehicles = data;
}

export function SetId(state, data) {
    state.client.id = data.id;
    state.params_contacts.contact_id = data.id;
    state.client.warehouses = data.warehouses;
    state.client.full_name = data.full_name;
}

export function setSelectedModel(state, data) {
    state.selected_model = data;
    state.client.price_list_id = state.selected_model.price_list_id;
}

/**
 * Establecer un valor para la variable client.
 */
export function setClient(state, client) {
    if (client && !client.customer) {
        client.customer = {
            required_purchase_order: 0
        };
    }

    state.client = client;

    if (client.customer) {
        state.client.price_list_id = client.customer.price_list_id;
    }

    if (state.client.warehouses.length && !state.client.warehouses[0].city) {
        state.client.warehouses[0].city = {
            department_id: null
        }
    }

    // Si el cliente tiene email_electronic_invoice, se establece como email, de lo contrario se establece como email del cliente
    state.client.email = client.email_electronic_invoice ? client.email_electronic_invoice : client.email;
}

export function setClientLite(state, client) {
    state.client = client;
}

/**
 * Establecer un valor para la variable tax_responsibilities.
 */
export function setTaxResponsibilities(state, tax_responsibilities) {
    state.tax_responsibilities = tax_responsibilities;
}

/**
 * Establecer un valor para el atributo from_identification de la variable params_contacts.
 */
export function setFromIdentificationToParamsContacts(state, from_identification) {
    state.params_contacts.from_identification = from_identification;
}

/**
 * Establecer un valor para el atributo contact_id de la variable params_contacts.
 */
export function resetContactIdToParamsContacts(state) {
    state.params_contacts.contact_id = null;
}

/**
 * Establecer un valor para el atributo show de la variable modal_question.
 */
export function setShowToModalQuestion(state, show) {
    state.modal_question.show = show;

    if (show) {
        setTimeout(() => {
            let new_customer = document.getElementById('new_customer');

            if (new_customer) {
                new_customer.focus();
            }
        }, 500);
    }
}

/**
 * Establecer un valor para el atributo identification de la variable client.
 */
export function setCheckDigitToClient(state) {

    let identification = state.client.identification.toString();

    let vpri,
        x,
        y,
        z;

    // Se limpia el Nit
    identification = identification.replace(/\s/g, ''); // Espacios
    identification = identification.replace(/,/g, ''); // Comas
    identification = identification.replace(/\./g, ''); // Puntos
    identification = identification.replace(/-/g, ''); // Guiones

    // Procedimiento
    vpri = new Array(16);
    z = identification.length;

    vpri[1] = 3;
    vpri[2] = 7;
    vpri[3] = 13;
    vpri[4] = 17;
    vpri[5] = 19;
    vpri[6] = 23;
    vpri[7] = 29;
    vpri[8] = 37;
    vpri[9] = 41;
    vpri[10] = 43;
    vpri[11] = 47;
    vpri[12] = 53;
    vpri[13] = 59;
    vpri[14] = 67;
    vpri[15] = 71;

    x = 0;
    y = 0;

    for (let i = 0; i < z; i++) {
        y = (identification.substr(i, 1));

        x += (y * vpri [z - i]);
    }

    y = x % 11;

    state.client.check_digit = (y > 1) ? 11 - y : y;
}

/**
 * Establecer un valor para el atributo identification_type de la variable client.
 */
export function setIdentificationTypeToClient(state) {

    let identification_code = '02';

    if (state.client.identification.length === 9) {
        identification_code = '01';
    }

    const identification_type = state.identificationTypes.find(it => it.code_parameter === identification_code);
    if (identification_type) {
        state.client.identification_type = identification_type.id;
    }
}

/**
 * Establecer un valor para la variable cities.
 */
export function setCities(state, cities) {
    state.cities = cities;
}

/**
 * Establecer un valor para la variable departments.
 */
export function setDepartments(state, departments) {
    state.departments = departments;
}

/**
 * Establecer un valor para el atributo with_contact_warehouses de la variable params_contacts.
 */
export function setWithContactWarehousesToParamsContacts(state, with_contact_warehouses) {
    state.params_contacts.with_contact_warehouses = with_contact_warehouses;
}

/**
 * Establecer un valor para la variable sellers.
 */
export function setSellers(state, sellers) {
    state.sellers = sellers;
}

/**
 * Establecer un valor para la variable subscriber.
 */
export function setSubscriber(state, subscriber) {
    state.subscriber = subscriber;
}

/**
 * Establecer un valor para la variable taxes.
 */
export function setTaxes(state, taxes) {
    state.taxes = taxes;
}

/**
 * Establecer un valor para la variable branch_office.
 */
export function setBranchOffice(state, branch_office) {
    state.branch_office = branch_office;
}

/**
 * Establecer un valor para la variable contact_warehouse.
 */
export function setContactWarehouse(state, contact_warehouse) {
    state.contact_warehouse = contact_warehouse;
}

/**
 * Establecer un valor para el atributo address de la variable client.
 */
export function setAddressToClient(state, address) {
    if (!!address) {
        state.client.address = address.toUpperCase();
    } else {
        state.client.address = '';
    }

}

export function setContactVehicleId (state, contact_vehicle_id) {
    state.client.contact_vehicle_id = contact_vehicle_id;
}

export function setClientDian (state, data) {
    state.client.name = data.name;
    state.client.email = data.email;
    state.client.surname = data.surname;
    state.client.is_dian = true;
}

function setDepartmentCityDefault (state) {
    const selected_branch_office = +localStorage.getItem('selected_branchoffice');

    if (selected_branch_office) {
        let branch_offices = localStorage.getItem('branchoffices');

        if (branch_offices) {
            const branch_office = JSON.parse(branch_offices).find(b => b.id === selected_branch_office);

            if (branch_office && branch_office.city && branch_office.city.department) {
                state.cities = [branch_office.city];
                state.departments = [branch_office.city.department];
            }
        }
    }
}

export function setClientInformationClient (state, client_information) {
    state.client = {
        ...state.client,
        ...client_information
    }
}

export function setDataClientInformation (state, data) {
    state.client_information = data;
}

export function setContactsLite (state, contacts) {
    state.contacts = contacts;
}

export function setOrderTypes (state, contacts) {
    state.orderTypes = contacts;
}


// WEBPACK FOOTER //
// ./src/modules/clients-component/mutations.js